import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { startAppZoom } from './utils/appZoom';
import { installLeadErrorListeners } from './services/leadClientErrors';
import { startLiquidPress } from './styles/liquidGlass';

// [LEAD-ERROR-LOG 2026-10-30] a script error on Lead Management reaches App Alerts
installLeadErrorListeners();

// [APP-FIT 2026-10-26] Lay the app out as on a 1920 px screen and scale it to this window — before the first render,so
// nothing is ever drawn at the wrong size (utils/appZoom.ts).
startAppZoom();

// [LIQUID-GLASS 2026-11-02, user] The soft light where a glass button is pressed (styles/liquidGlass.ts).
startLiquidPress();

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
